/**
 * thời gian thực hiện
 */
export default {
  Equal: 5,
  Contain: 10,
  StartWith: 15,
  EndWith: 20,
};
